import { render, staticRenderFns } from "./ProjectCardSearchResult.vue?vue&type=template&id=3cfb6ca9&"
import script from "./ProjectCardSearchResult.vue?vue&type=script&lang=js&"
export * from "./ProjectCardSearchResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports